import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  height: 100%;
  width: 100%;
  max-width: 1180px;
  margin: -62px auto 0 auto;

  background-color: ${(p) => p.theme.formBackgroundColor};

  > div:nth-child(2) {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
`;
